// extracted by mini-css-extract-plugin
module.exports = {"loader":"styles_loader__39rgs","cardHeader":"styles_cardHeader__FXsTi"};